import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { AppConfigService } from "src/app/configs/app-config.service";

@Pipe({
	name: "assetsSource",
})
@Injectable({
	providedIn: "root",
})
export class AssetsSourcePipe implements PipeTransform {
	private assetsURL: string;

	constructor(private config: AppConfigService) {
		this.assetsURL = this.config.get("brand");
	}

	transform(imgName: string): string {
		return `assets/${this.assetsURL}/images/${imgName}`;
	}
}
